/** TermsReacceptGate — listens for axios 403 TERMS_REACCEPTANCE_REQUIRED. */
import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import TermsReacceptModal from './TermsReacceptModal';
interface PendingTerm { document_type: 'tos' | 'privacy' | 'dpa'; version: string; }
const EVENT = 'janus:terms-reacceptance-required';
let attached = false;
function attach() {
  if (attached) return;
  attached = true;
  api.interceptors.response.use((r) => r, (err) => {
    const status = err?.response?.status;
    const body = err?.response?.data;
    const code = body?.error?.code || body?.detail;
    if (status === 403 && code === 'TERMS_REACCEPTANCE_REQUIRED') {
      const pending: PendingTerm[] = body?.error?.details?.pending || [];
      window.dispatchEvent(new CustomEvent(EVENT, { detail: { pending } }));
    }
    return Promise.reject(err);
  });
}
export const TermsReacceptGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [pending, setPending] = useState<PendingTerm[]>([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    attach();
    const handler = (e: Event) => {
      const d = (e as CustomEvent<{ pending: PendingTerm[] }>).detail;
      if (d?.pending?.length) { setPending(d.pending); setOpen(true); }
    };
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);
  return <>{children}<TermsReacceptModal open={open} pending={pending} onAccepted={() => { setOpen(false); window.location.reload(); }} /></>;
};
export default TermsReacceptGate;
